<template lang="pug">
.refund-shipping-instructions
  .refund-shipping-layout
    .box-mark-panel
      .box-mark-panel__figure(
        role="img"
        :aria-label="`Envío con número de orden ${orderNumberDisplay}`"
      )
        img.box-mark-panel__img(
          src="https://sahet-cdn.b-cdn.net/img/others/box.jpg"
          alt=""
          loading="lazy"
          decoding="async"
        )
        .box-mark-panel__order-overlay(aria-hidden="true")
          span.box-mark-panel__order-on-box {{ orderNumberDisplay }}

      .box-mark-panel__notice-wrap
        .inline-notice.inline-notice--warning
          | Marca tu envío con el número 
          strong {{ orderNumberDisplay }}

    .shipping-data-section
      h3.shipping-data-heading Enviar a:
      .shipping-data
        .shipping-row.shipping-row--multiline
          span.shipping-label Destinatario:
          span.shipping-value {{ recipientLine }}

        .shipping-row.shipping-row--multiline
          span.shipping-label Dirección:
          span.shipping-value {{ addressLine }}

        .shipping-row.shipping-row--carriers
          span.shipping-label Enviar por:
          span.shipping-value.shipping-carriers
            .shipping-carrier-logos
              img.shipping-carrier-logo(
                src="https://sahet-cdn.b-cdn.net/img/conveyors/light/interrapidisimo.png"
                alt="Interrapidísimo"
                loading="lazy"
                decoding="async"
              )
              img.shipping-carrier-logo.shipping-carrier-logo--envia(
                src="https://sahet-cdn.b-cdn.net/img/conveyors/envia.png"
                alt="Envía"
                loading="lazy"
                decoding="async"
              )
            span.shipping-carrier-insurance — Asegurar por valor mínimo
</template>

<script>
const REFUND_SHIP_NIT = '901451100'
const REFUND_SHIP_PHONE = '3507501085'
const REFUND_SHIP_COMPANY = 'N89 SAS'
const REFUND_SHIP_CITY = 'Bogotá'

export default {
  name: 'RefundShippingInstructions',

  props: {
    orderNumber: {
      type: String,
      default: ''
    }
  },

  computed: {
    addressLine () {
      return `Calle 37 b sur 68i 23 — ${REFUND_SHIP_CITY}`
    },
    recipientLine () {
      return `${REFUND_SHIP_COMPANY} — NIT ${REFUND_SHIP_NIT} — cel: ${REFUND_SHIP_PHONE}`
    },
    orderNumberDisplay () {
      const raw = (this.orderNumber && String(this.orderNumber).trim()) || ''
      if (!raw) return ''
      return raw
        .split(/\s+/)
        .map(part => part.replace(/^s+/i, '').trim())
        .filter(Boolean)
        .join(' ')
        .toUpperCase()
    }
  }
}
</script>

<style lang="stylus" scoped>
.refund-shipping-instructions
  font-size 1.08rem
  line-height 1.45
  text-align left

.refund-shipping-layout
  display flex
  flex-direction column
  align-items flex-start
  gap 1rem 0

.shipping-data-section
  flex none
  width 100%
  min-width 0

.shipping-data-heading
  margin 0 0 .55rem
  font-size 1.05rem
  font-weight 600
  line-height 1.3
  color rgba(0, 0, 0, 0.72)

.shipping-data
  flex none
  width 100%
  margin 0
  min-width 0
  padding .75rem 1.15rem
  border 1px solid rgba(0, 0, 0, 0.15)

.box-mark-panel
  display flex
  flex-direction row
  flex-wrap wrap
  align-items center
  gap .85rem 1.15rem
  flex none
  width 100%
  max-width 100%

.box-mark-panel__notice-wrap
  flex 1 1 12rem
  min-width 0
  max-width 100%
  align-self center

.box-mark-panel__figure
  position relative
  flex none
  width 12.5rem
  max-width 100%
  min-width 9rem
  container-type inline-size
  overflow visible
  background transparent

.box-mark-panel__img
  display block
  width 100%
  height auto
  vertical-align top
  border-radius 6px
  border 1px solid rgba(0, 0, 0, 0.1)

.box-mark-panel__order-overlay
  position absolute
  left 0
  right 0
  top 38%
  bottom 14%
  display flex
  align-items center
  justify-content center
  padding 0 .28rem
  pointer-events none

.box-mark-panel__order-on-box
  width 100%
  max-width 82%
  font-size .8rem
  font-weight 800
  letter-spacing .05em
  line-height 1.1
  text-align center
  color #1a1a1a
  text-shadow 0 0 1px rgba(255, 255, 255, 0.95), 0 1px 2px rgba(255, 255, 255, 0.85)
  word-break break-all
  hyphens none
  transform-origin 40% 58%
  transform skewX(-5deg) rotateZ(8deg) translate(-13%, -31%)

.inline-notice
  margin-top 0
  margin-bottom 0
  padding .65rem .85rem
  font-size .95rem
  line-height 1.55

.inline-notice--warning
  background rgba(230, 168, 0, 0.12)
  border-left 3px solid #e6a800
  color #5c4500

.shipping-row
  display grid
  grid-template-columns minmax(6.5rem, 8.5rem) minmax(0, 1fr)
  column-gap 1rem
  align-items baseline
  padding .35rem 0
  border-bottom 1px solid rgba(0, 0, 0, 0.06)

  &:last-child
    border-bottom none

.shipping-label
  font-weight 600
  font-size 1.02rem
  color rgba(0, 0, 0, 0.55)
  margin 0
  padding 0

.shipping-value
  margin 0
  padding 0
  min-width 0
  font-weight 500

.shipping-row--multiline .shipping-value
  line-height 1.5

.shipping-row--carriers
  align-items center

  .shipping-value
    min-width 0

.shipping-carriers
  display flex
  flex-wrap wrap
  align-items center
  gap .5rem .75rem

.shipping-carrier-logos
  display flex
  flex-wrap wrap
  align-items center
  gap .5rem .75rem
  flex-shrink 0

.shipping-carrier-logo
  display block
  width auto
  max-width 6.1rem
  max-height 1.68rem
  height auto
  object-fit contain

.shipping-carrier-logo--envia
  max-width 4rem
  max-height 1.12rem

.shipping-carrier-insurance
  font-size .95rem
  font-weight 400
  color rgba(0, 0, 0, 0.58)
  line-height 1.35
  white-space nowrap
</style>



// WEBPACK FOOTER //
// src/components/pages/order/refund/RefundShippingInstructions.vue